PLAN_PERIOD_FOURTEEN_DAYS